import Vue from 'vue'
import ParseHelper from './ParseHelper'
import * as NameSpace from 'src/store/NameSpace'
import loaderState from 'src/store/modules/loader'
import { MERCHANT_ROLE } from 'src/constants/Constants'
import { uploadedOffersResponseHelper } from 'src/components/shared/helper/ParseObjectToArrayConverter'
import * as ViewKeyToServerKeyMapper from 'src/components/shared/helper/ViewKeyToServerKeyMapper'

/**
* Pass the mutation function to reduce the text length
* This function can now be used in the api calls to start/stop the loader
* as the api starts and finishes.
*/
let loaderSwitch = loaderState.mutations[NameSpace.MUTATE_LOADER_STATE].bind(null, loaderState.state)

Vue.use(ParseHelper, {
  'appId': '74835-54897-3473865-437684',
  'url': getParseEndpoint(process.env.NODE_ENV)
})

function getParseEndpoint (env) {
  if (env === 'development') {
    return 'http://104.198.218.85:1337/parse'
  } else if (env === 'production') {
    return 'https://pspvendor.impactanalytics.co/parse'
  }
}

function errorHelper (errorCode, error) {
  console.log(errorCode, error)
  switch (errorCode) {
    case 100: return `Cannot establish connection with the server.`
    case 101: return `The combination of username and password you provided doesn't match with our records.`
    case 130: return 'Your file could not be uploaded.'
    case 141: return error.message.message || error.message.error || error
    case 209: return `Your session has expired, please login again.`
    case 210: return `You are not authorized to login, please check your credentials or role.`
    case 205: return error.message.message || error.message.error || error
    default: return `This is an unexpected error. Please try again in a while`
  }
}

function cloudRunner (functionName, requestData) {
  loaderSwitch(true)
  return new Promise((resolve, reject) => {
    RestClient.$parse().Cloud.run(functionName, requestData, {
      success (response) {
        loaderSwitch(false)
        if (response.success) {
          if (
            functionName === 'getItemsByOfferId' ||
            functionName === 'getHighLevelOffers' ||
            functionName === 'getAggregatedOffers' ||
            functionName === 'getEditOfferItems' ||
            functionName === 'removeItemById' ||
            functionName === 'approveWithChanges' ||
            functionName === 'updatePetDepotFunding' ||
            functionName === 'approveOffer' ||
            functionName === 'updateZonePrices' ||
            functionName === 'getLiftSimulation' ||
            functionName === 'applySimulationDecision'
          ) {
            resolve(response)
          } else {
            console.log('In cloudRunner 1:', response)
            resolve(response.data)
          }
        } else {
          console.log('In cloudRunner 2:', response)
          reject(response)
        }
      },
      error (error) {
        loaderSwitch(false)
        console.log('In cloudRunner 3:', error)
        reject(errorHelper(error.code, error))
        if (error.code === 209) { // parseSDK error code for session expiry
          const authState = require('src/store/modules/authorization').default
          console.log(authState)
          let authExpiry = authState.mutations[NameSpace.MUTATE_AUTH_EXPIRY].bind(null, authState.state)
          localStorage.removeItem('Parse/74835-54897-3473865-437684/currentUser')
          authExpiry(true)
        }
      }
    })
  })
}

function checkNotAuthorize (user) {
  let userGroup = user.attributes.user_group
  if (userGroup) {
    if (userGroup.indexOf(MERCHANT_ROLE) !== -1) {
      return false
    } else {
      return true
    }
    // if (userGroup.indexOf(SUPER_USER_ROLE) !== -1) {
    //   return false
    // } else if (userGroup.indexOf(MERCHANT_ROLE) !== -1) {
    //   return false
    // } else {
    //   return true
    // }
  }
}

export const ParseService = {
  login (username, password) {
    loaderSwitch(true)
    return new Promise((resolve, reject) => {
      RestClient.$parse().User.logIn(username, password, {
        success (user) {
          loaderSwitch(false)
          if (checkNotAuthorize(user)) {
            localStorage.clear()
            reject(errorHelper(210))
          }
          resolve(user.attributes)
        },
        error (user, error) {
          loaderSwitch(false)
          reject(errorHelper(error.code))
        }
      })
    })
  },
  fileUpload (payload) {
    let parse = RestClient.$parse()
    let parseFile = new parse.File(payload.name, payload.file)
    loaderSwitch(true)
    // let vendorId = getVendorId()
    // if (isSuperUser() && vendorId) {
    //   payload.vendorId = vendorId.value
    // }
    return new Promise((resolve, reject) => {
      parseFile.save({
        success: function (object) {
          ParseService.uploadedOffers({url: object.url(), period: payload.period}, payload.filterArray)
          .then(result => {
            parseFile = null
            loaderSwitch(false)
            resolve(result)
          })
          .catch(error => {
            parseFile = null
            loaderSwitch(false)
            reject(error)
          })
        },
        error: function (model, error) {
          parseFile = null
          loaderSwitch(false)
          reject(
            errorHelper(
              JSON.parse(error.responseText || error.response)['code'] || error.code
            )
          )
        }
      })
    })
  },
  uploadedOffers (data, filterArray) {
    loaderSwitch(true)
    return new Promise((resolve, reject) => {
      cloudRunner('merchantUpload', data)
        .then(function (response) {
          loaderSwitch(false)
          if (Array.isArray(response)) {
            resolve(uploadedOffersResponseHelper(response, ViewKeyToServerKeyMapper.SubmitOfferTableKeys, filterArray))
          } else {
            resolve(response)
          }
        })
        .catch(error => {
          loaderSwitch(false)
          reject(error)
        })
    })
  },
  updateProfile (data) { return cloudRunner('updateProfile', data) },
  // getItemsByOfferId (data) { return cloudRunner('getItemsByOfferId', data) },
  getApproveOffers (data) { return cloudRunner('goalsAndDisplayDetails', data) },
  getOfferNames (data) { return cloudRunner('getOfferNames', data) },
  approveOffer (data) { return cloudRunner('approveOffer', data) },
  rejectOffer (data) { return cloudRunner('rejectOffer', data) },
  getOfferDetails (data) { return cloudRunner('getItemsByOfferId', data) },
  getLandingData (data) { return cloudRunner('merchantLandingInit', data) },
  getSubDepartments (data) { return cloudRunner('getSubDepartments', data) },
  getClasses (data) { return cloudRunner('getClasses', data) },
  getSubClasses (data) { return cloudRunner('getSubClasses', data) },
  getHighLevelOffers (data) { return cloudRunner('getHighLevelOffers', data) },
  getAggregatedOffers (data) { return cloudRunner('getAggregatedOffers', data) },
  getEditOfferItems (data) { return cloudRunner('getEditOfferItems', data) },
  approveWithChanges (data) { return cloudRunner('approveWithChanges', data) },
  updatePetDepotFunding (data) { return cloudRunner('updatePetDepotFunding', data) },
  updateZonePrices (data) { return cloudRunner('updateZonePrices', data) },
  getGraphData (data) { return cloudRunner('getGraphData', data) },
  getLiftSimulation (data) { return cloudRunner('getLiftSimulation', data) },
  getWaterFallData (data) { return cloudRunner('getWaterFallData', data) },
  downloadMerchantAllDetails (data) { return cloudRunner('downloadMerchantAllDetails', data) },
  downloadManufacturerInfo (data) { return cloudRunner('downloadMerchantManufacturerInfo', data) },
  downloadTemplateMerchant (data) { return cloudRunner('downloadTemplateMerchant', data) },
  downloadNegativeMarginItems (data) { return cloudRunner('downloadNegativeMarginItems', data) },
  downloadDax (data) { return cloudRunner('createDax', data) },
  removeItemById (data) { return cloudRunner('removeItemById', data) },
  getManufacturersForSuperUser (data) { return cloudRunner('getManufacturersForSuperUser', data) },
  refreshLiftChanges (data) { return cloudRunner('refreshLiftChanges', data) },
  applySimulationDecision (data) { return cloudRunner('applySimulationDecision', data) },
  sendFinalConfirmationMails (data) { return cloudRunner('sendFinalConfirmationMails', data) },
  forgotPassword (username) {
    loaderSwitch(true)
    return new Promise((resolve, reject) => {
      RestClient.$parse().User.requestPasswordReset(username, {
        success (user) {
          loaderSwitch(false)
          resolve('Password reset request was sent successfully')
        },
        error (user, error) {
          loaderSwitch(false)
          reject(errorHelper(user.code, user))
        }
      })
    })
  }
}

export const RestClient = new Vue()



// WEBPACK FOOTER //
// ./src/Services/parse/index.js